import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular/standalone';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgIf } from '@angular/common';
import { IonContent } from '@ionic/angular/standalone';
import { DivClickDirective } from 'src/app/directives/div-click.directive';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.page.html',
  standalone: true,
  imports: [
    NgIf,
    InlineSVGModule,
    DivClickDirective,
    TranslateModule,
    IonContent,
  ],
})
export class OnboardingPage implements OnInit {
  appIcon: string;
  appName: string;

  constructor(
    private app: CurrentWhiteLabelApplication,
    private router: Router,
    private translate: TranslateService
  ) {
    this.appIcon = this.app.getIconThumbnails()?.small;
    this.appName = this.app.getName();
  }

  ngOnInit() {}

  start() {
    this.router.navigate(['onboarding', 'notifications'], {
      replaceUrl: true,
    });
  }

  async openPrivacyStatement() {
    Browser.open({ url: this.translate.instant('page.settings.privacy.url') });
  }
}
